import { useState } from "react";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { Box, Flex, HStack } from "@chakra-ui/react";
import { Dots } from "modules/common/components/Trustpilot/Dots";
import { TeamCard } from "./TeamCard";
import type { TeamCardsProps } from "./TeamCards.d";

export const TeamCardsMobile = ({ cards }: TeamCardsProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    mode: "snap",
    slides: {
      origin: "auto",
      perView: "auto",
    },

    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
  });

  const goToSlide = (slideIndex: number) => instanceRef.current?.moveToIdx(slideIndex);

  return (
    <>
      <Box ref={sliderRef} className="keen-slider" pb={6}>
        {cards.map((card) => (
          <Flex className="keen-slider__slide" key={card.name} minW="fit-content" maxW="fit-content">
            <HStack spacing={4} align="stretch" px={4}>
              <TeamCard {...card} />
            </HStack>
          </Flex>
        ))}
      </Box>
      <Box mx="auto">
        <Dots currentSlide={currentSlide} numberOfSlides={cards.length} goToSlide={goToSlide} color="primary.500" />
      </Box>
    </>
  );
};
